import { TimeInterval } from "@/models";
import WithTimeIntervals from "@/models/interfaces/WithTimeIntervals";

export default class HourInlineComparisonHelper {
  static SlideData<T extends WithTimeIntervals>(ingress: T[], by: number): T[] {
    if (ingress.length === 0) {
      return [];
    }
    const toBeReversed = ingress[0].timeIntervals.slice(by);
    toBeReversed.push(...ingress[0].timeIntervals.slice(0, by));

    const entry = Object.assign({}, ingress[0], {
      timeIntervals: toBeReversed,
    });

    return [entry];
  }

  static ReduceData<T extends WithTimeIntervals & { name: string }>(
    ingress: T[]
  ): T[] {
    if (ingress.length <= 1) {
      return ingress;
    }
    const timeIntervals: TimeInterval[][] = ingress.map((element) => {
      return element.timeIntervals;
    });
    const first = timeIntervals[0] as TimeInterval[];
    for (let i = 1; i < timeIntervals.length; i++) {
      const current = timeIntervals[i];
      current.forEach((element: TimeInterval, idx) => {
        const obj = first[idx];
        obj.vodDetection = obj.vodDetection ?? 0;
        obj.ebiquityMax = obj.ebiquityMax ?? 0;
        obj.ebiquityMin = obj.ebiquityMin ?? 0;
        obj.creativitiesCount += element.creativitiesCount;
        obj.detectionsCount += element.detectionsCount;
        obj.radioDetectionsCount += element.radioDetectionsCount;
        obj.radioSecondsCount += element.radioSecondsCount;
        obj.secondsCount += element.secondsCount;
        obj.tvDetectionsCount += element.tvDetectionsCount;
        obj.tvSecondsCount += element.tvSecondsCount;
        obj.ebiquityMin += element.ebiquityMin ?? 0;
        obj.ebiquityMax += element.ebiquityMax ?? 0;
        obj.vodDetection += element.vodDetection ?? 0;
        first[idx] = obj;
      });
    }
    const entry = Object.assign({}, ingress[0], {
      name: "Aggregated",
      timeIntervals: [...first],
    });

    return [entry];
  }
}
